import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { ScoreBar } from '../../../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/ScoreBar.js';
import { Flex, ParagraphMedium, LabelMedium } from '../../../../../../../primitives/index.js';
export const RatingGroup = ({
  ratingGroupId,
  ratingGroup
}) => {
  const {
    t
  } = useTranslation('hotelDetailsOverlay');
  return _jsxs(Flex, {
    spacing: "4px",
    children: [_jsx(LabelMedium, {
      children: t(`amadeusRatingSection.groups.${ratingGroupId}`)
    }), _jsx(ScoreBar, {
      rating: ratingGroup.rating,
      contained: true
    }), ratingGroup.conclusion && _jsx(ParagraphMedium, {
      children: ratingGroup.conclusion
    })]
  });
};